module.exports = __webpack_public_path__ + "img/7minutos5.e670e68e.jpg";